module.exports = __webpack_public_path__ + "img/17a003-03.a354daaf.jpg";